// import React, { useEffect, useState } from 'react';
// import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip } from 'chart.js';
// import { PolarArea } from 'react-chartjs-2';
// import apiService from 'app/services/apiService';
// ChartJS.register(RadialLinearScale, ArcElement, Tooltip);
// export default function PolarAreaChart() {
//   const [structuredData, setStructuredData] = useState([]);
//   const [clicked, setClicked] = useState('');
//   const spreadValues = structuredData?.map(obj => obj.spread);
//   const labelValues = structuredData?.map(obj => obj.name);
//   const data = {
//     labels: [...labelValues],
//     datasets: [
//       {
//         label: '# of Votes',
//         data: [...spreadValues],
//         backgroundColor: [
//           'rgba(255,96,6,0.5)',
//           'rgba(36,54,91,0.5)',
//           'rgba(253,236,184,0.5)',
//           'rgba(153, 102, 255, 0.5)',
//           'rgba(255, 159, 64, 0.5)',
//         ],
//         borderWidth: 10,
//       },
//     ],
//   };
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await apiService.structuredChartData();
//         setStructuredData(response?.data?.structured?.dataClassLevelSpread);
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchData();
//   }, []);
//   return (
//     <PolarArea
//       data={data}
//       options={{
//         scales: {
//           r: {
//             display: false,
//             grid: {
//               display: false,
//             },
//             ticks: {
//               display: false,
//             },
//           },
//         },
//       }}
//     />
//   );
// }
import React from 'react';
import { Chart as ChartJS, RadialLinearScale, ArcElement } from 'chart.js';
import { PolarArea } from 'react-chartjs-2';

ChartJS.register(RadialLinearScale, ArcElement);

export default function PolarAreaChart({ structuredData, setClicked, clicked }) {
  // const [structuredData, setStructuredData] = useState([]);

  const spreadValues = structuredData?.map(obj => obj.spread);
  const labelValues = structuredData?.map(obj => obj.name);

  const data = {
    labels: [...labelValues],
    datasets: [
      {
        label: '# of Votes',
        data: [...spreadValues],
        backgroundColor: [
          !clicked || clicked === 'n0' ? '#FA5C43' : '#ffded9',
          !clicked || clicked === 'n1' ? '#273658' : '#aeb4c2',
          !clicked || clicked === 'n2' ? '#fadd87' : '#f7f2e1',
          !clicked || clicked === 'n3' ? '#6498fa' : '#e4eaf5',
          !clicked || clicked === 'n4' ? 'rgba(255, 159, 64, 0.9)' : 'rgba(255, 159, 64, 0.3)',
        ],
        borderWidth: 10,
        datalabels: {
          display: true,
          align: 'center',
          anchor: 'center',
        },
      },
    ],
  };

  const handleClick = (event, elements) => {
    if (elements?.length) {
      const clickedLabel = data.labels[elements[0].index];
      setClicked(clickedLabel);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await apiService.structuredChartData();
  //       setStructuredData(response?.data?.structured?.dataClassLevelSpread);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  return (
    <PolarArea
      data={data}
      options={{
        onClick: handleClick, // add onClick handler
        scales: {
          r: {
            display: false,
            grid: {
              display: false,
            },
            ticks: {
              display: false,
            },
          },
        },
        plugins: {
          tooltip: {
            // backgroundColor: '#FFF',
            // bodyFontColor: '#000',
            borderColor: '#000',
            borderWidth: 0,
            cornerRadius: 5,
            displayColors: false,
            xPadding: 10,
            yPadding: 10,
            titleFontColor: '#000',
            titleFontSize: 14,
            titleAlign: 'center',
            bodyAlign: 'center',
            maxWidth: 200, // set the maximum width of the tooltip
          },
        },
      }}
    />
  );
}
